import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Route, Switch} from "react-router-dom";
import './App.css';
import HomePage from "./components/pages/HomePage";
import GenericPage from "./components/pages/GenericPage";
import ContactUsPage from "./components/pages/ContactUsPage";
import Modal from "./components/elements/Modal";
import NewsListPage from "./components/pages/NewsListPage";
import NewsPage from "./components/pages/NewsPage";
import RegionListPage from "./components/pages/RegionListPage";
import RegionPage from "./components/pages/RegionPage";
import {openModal} from "./actions/modal";
import StandardsPage from "./components/pages/StandardsPage";
import {Helmet} from 'react-helmet';
import ReactGA from 'react-ga';




import {initApp} from "./actions/init";

class App extends Component {

    initializeReactGA() {
        ReactGA.initialize('UA-123791717-1');
        ReactGA.pageview('/homepage');
    }

    componentDidMount() {
        this.props.initApp().then((data) => {
              const cta = data
              if(cta.enableCallToAction === true) {
                  setTimeout(
                    () => {
                        if (localStorage.getItem('cta') === null) {

                            this.props.openModal('cta', cta)
                            //localStorage.setItem('cta', true);
                        }
                    },
                    3000
                  )
              }
          }
        );

    }


    render() {
        const {location, seo} = this.props;
        let quotation;


        if(this.props.seo){
            quotation =
              <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta property="fb:app_id" content=""/>
                <meta property="og:url" content={seo.url}  />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={seo.title} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:site_name" content={seo.title} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="ayacancernetwork.org.nz" />
                <meta name="twitter:url" content={seo.url} />
                <meta name="twitter:title" content={seo.title} />
                <meta name="twitter:description" content={seo.description} />
                <meta name="twitter:image" content={seo.image} />
            </Helmet> ;
        }else{
            quotation = '';
        }


        return (
          <div>

              {quotation}
              <Switch>
              <Route
                                    location={location}
                                    path="/"
                                    exact
                                    component={HomePage}/>
                                  <Route
                                    location={location}
                                    path="/regions"
                                    exact
                                    component={RegionListPage}/>
                                  <Route
                                    location={location}
                                    path="/standardsofcare"
                                    exact
                                    component={StandardsPage}/>
                                  <Route
                                    location={location}
                                    path="/have-your-say"
                                    exact
                                    component={ContactUsPage}/>
                                  <Route
                                    location={location}
                                    path="/news"
                                    exact
                                    component={NewsListPage}/>
                                  <Route
                                    location={location}
                                    path="/contact-us"
                                    exact
                                    component={ContactUsPage}/>
                                  <Route
                                    location={location}
                                    path="/regions/:id"
                                    exact
                                    component={RegionPage}/>
                                  <Route
                                    location={location}
                                    path="/news/:id"
                                    exact
                                    component={NewsPage}/>
                                  <Route
                                    location={location}
                                    path="/:id"
                                    component={GenericPage}/>
              </Switch>

              <Modal/>
          </div>
        );
    }
}

App.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }),
    initApp: PropTypes.func.isRequired
};
App.defaultProps = {seo: []};

function mapStateToProps(state) {
    return {
        routes: state.routes,
        modal: state.modal,
        navigation: state.navigation,
        seo: state.page.seo,
    };
}


export default connect(mapStateToProps, {initApp, openModal})(App);



// WEBPACK FOOTER //
// ./src/App.js